export default {
  TIKTOK: {
    TITLE: 'Perfil de Candidat@ - Vista Wokap',
    NAVBAR_TITLE_PREFIX: 'Oferta',
    PAGE_TITLE: '{{ offerTitle }} - Vista Wokap',
    SEARCH_MODAL_TITLE: 'Escribe el nombre de la persona',
    TABLE_OCCUPATION_HEADER: 'Ocupación | Profesión',
    TABLE_LOCATION_HEADER: 'Ubicación',
    TABLE_APPLICATION_DATE_HEADER: 'Fecha de postulación',
    LAST_CANDIDATE: {
      NO_MORE: 'No hay más candidat@s en {{stage}}.',
      WANT_TO_SEE: '¿Quieres ver l@s candidat@s de la siguiente etapa:',
      ACCESS_FROM_TABS: 'Accede a cualquier etapa desde los tabs superiores.',
      VIEW_STAGE: 'Ir a candidat@s – {{stage}}',
      VIEW_ALL: 'Ver tod@s l@s candidat@s',
      SUGGESTED_NO_MORE: 'No hay más candidat@s Sugerid@s.',
      SUGGESTED_SEARCHING: 'wokap seguirá buscando perfiles que encajen con tu oferta.',
      SUGGESTED_MEANWHILE: 'Mientras tanto, revisa l@s candidat@s que ya se inscribieron.',
      SUGGESTED_WANT_FIRST_STAGE: '¿Quieres ver l@s candidat@s de la primera etapa:',
      SUGGESTED_VIEW_ENROLLED: 'Ir a candidat@s – Por Revisar',
    },
    ACTIONS: {
      TITLE: 'Acciones',
      TITLE_OFFER: ' Oferta',
      PIN_IN_PANEL: 'Fijar oferta en Panel de ofertas',
      UNPIN_IN_PANEL: 'Desfijar oferta del Panel de ofertas',
      VIEW: 'Ver oferta',
      VIEW_EDIT: 'Ver / Editar oferta',
      SHARE: 'Compartir oferta',
      DUPLICATE: 'Duplicar oferta',
      EDIT_INTERVIEW: 'Crear / Editar entrevista',
      PAUSE: 'Pausar oferta',
      START: 'Reactivar oferta',
      END: 'Finalizar oferta',
      DELETE: 'Eliminar oferta',
      // Tooltips personalizados para estados deshabilitados
      VIEW_EDIT_DISABLED_CLOSED: 'Esta oferta está cerrada. Puedes verla, pero no editarla',
      SHARE_DISABLED_PAUSED: 'Esta oferta está pausada, no puedes compartirla',
      SHARE_DISABLED_CLOSED: 'Esta oferta está cerrada, no puedes compartirla',
      EDIT_INTERVIEW_DISABLED_CLOSED: 'Esta oferta está cerrada, no puedes crear ni editar entrevistas',
      PAUSE_DISABLED_CLOSED: 'Esta oferta está cerrada, no puedes pausarla',
      END_DISABLED_CLOSED: 'Esta oferta está cerrada, no puedes finalizarla nuevamente',
      CREATE_INTERVIEW_TOOLTIP: 'Crear entrevista',
      EDIT_INTERVIEW_TOOLTIP: 'Editar entrevista',
      PREVIEW_TOOLTIP: 'Vista previa',
      // Ref: docs/libraries/Angular v18 Documentation.txt
      PREVIEW_MODAL_INFO: 'Esta es solo una vista previa de cómo l@s candidat@s verán tu oferta en la app de wokap. Para probarla tú mism@, descarga la app de wokap.',
      EDIT_OFFER_TOOLTIP: 'Edita la información y configuración de la oferta',
      EDIT_OFFER_DISABLED_CLOSED: 'Esta oferta ha sido finalizada, ya no es posible editar su información',
      LABEL: {
        PIN: 'Fijar',
        UNPIN: 'Desfijar',
        VIEW: 'Ver',
        VIEW_EDIT: 'Ver/Editar',
        SHARE: 'Compartir/Copiar',
        COPY_LINK: 'Copiar link',
        COPY_DATA: 'Copiar datos',
        COPY_QR: 'Copiar QR',
        PREVIEW: 'Vista previa',
        EDIT_OFFER: 'Editar oferta',
        DUPLICATE: 'Duplicar',
        CREATE_INTERVIEW: 'Crear entrevista',
        EDIT_INTERVIEW: 'Editar entrevista',
        PAUSE: 'Pausar',
        START: 'Reactivar',
        END: 'Finalizar',
        DELETE: 'Eliminar',
      },
    },
    VIEWS: {
      TITLE: 'Vista',
      TOOLTIP: 'Explora las 3 vistas disponibles para navegar entre candidat@s. Cada una te ofrece diferentes funciones para evaluar y organizar tu proceso',
      LIST: 'Lista',
      CARDS: 'Tarjetas',
      WOKAP: 'wokap',
      COMPACT: 'Vista Compacta',
      EXPANDED: 'Vista Expandida',
      PANEL: 'Ir a Panel de ofertas',
    },
    WOKAP_AI: { TOOLTIP: 'Encuentra tu candidat@ ideal en la red de wokap' },
    ACTIONS_DISABLED: {
      NOT_ENROLLED: 'Esta persona aún no se ha inscrito en la oferta. Invítal@ para poder gestionar su proceso',
      NOT_ENROLLED_VIEW_PROFILE: 'Esta persona aún no se ha inscrito a la oferta. Invítal@ para poder ver su perfil completo.',
      DISCARDED: 'Candidat@ está descartad@. No es posible avanzarl@ a la siguiente etapa',
      INTERVIEW_ANSWERED: 'Él/la candidat@ ya ha respondido la entrevista. Para verla, desliza hacia abajo hasta la sección «Entrevista».',
    },
    TABS: {
      FILTER: 'Filtrar tus candidat@s',
      SEARCH: 'Buscar candidat@s',
      KILLER_QUESTIONS: 'Killer Questions',
      NAVIGATE: 'Navega por wokap',
      SUGGESTED: 'Candidat@s sugeridos',
    },
    STATUS: {
      ALL: 'Inscrit@s',
      ENROLLED: 'Por revisar',
      TO_REVIEW: 'Por revisar',
      PROCESS: 'Preseleccionad@s',
      IN_PROGRESS: 'Preseleccionad@s',
      PRESELECTED: 'Preseleccionad@s',
      FINALISTS: 'Finalistas',
      SELECTED: 'Finalistas',
      DISCARDED: 'Descartad@s',
      SUGGESTED: 'Sugerid@s',
      UNKNOWN: 'Estado desconocido',
    },
    OFFER: 'Oferta',
    CANDIDATE_NAME: 'Nombre',
    LOCATION: 'Ubicación',
    APPLICATION: 'Postulación',
    OCCUPATION: 'Ocupación | Profesión',
    APPLICATION_DATE: 'Postulación',
    STATUS_LABEL: 'Estado',
    RATING: 'Valoración',
    MATCH_TITLE: 'Coincidencia con Oferta (beta)',
    MATCH_DISCLAIMER1: 'Basada en la información proporcionada por el/la candidat@ al inscribirse en la oferta. ',
    MATCH_DISCLAIMER1_5: 'La coincidencia es una estimación orientativa y depende de los requisitos de la oferta y de los datos introducidos por el/la candidat@.',
    MATCH_DISCLAIMER2: 'Puede haber errores. Comprueba la información antes de tomar decisiones.',
    MATCH_DISCLAIMER3: 'Consulta ',
    MATCH_DISCLAIMER3_LINK: 'Preferencias de cookies.',
    SHARE_DISABLE: 'El/la candidat@ ya está inscrit@ en esta oferta. No es necesario volver a invitarl@',
    SHARE_ENABLE: 'Invita a esta persona a inscribirse en la oferta. Cuando lo haga, podrás gestionar su proceso',
    SHARE_ALREADY_SENT: 'Tú o alguien de tu empresa ya invitó a esta persona a inscribirse en la oferta. Cuando acepte la invitación, podrás gestionar su proceso',
    REQUIREMENTS_TITLE: 'Requisitos, Aptitudes, Habilidades e Idioma',
    COMPACT_VIEW: '📋 Vista Compacta',
    EXPANDED_VIEW: '📖 Vista Expandida',
    MINIMUM_REQUIREMENTS: 'Requisitos Mínimos',
    DESIRED_REQUIREMENTS: 'Requisitos Deseados',
    HARD_SKILLS: 'Aptitudes Técnicas (hard skills)',
    SOFT_SKILLS: 'Aptitudes Interpersonales (soft skills)',
    SOFT_SKILLS_PREVIEW: 'Liderazgo, Comunicación Efectiva...',
    TOOLS: 'Otras Competencias',
    TOOLS_PREVIEW: 'Otras Competencias...',
    LANGUAGES: 'Idiomas',
    NO_LANGUAGES: '{{ name }} no ha registrado ningún idioma.',
    LANGUAGE_NAMES: {
      ES: 'Español',
      EN: 'Inglés',
      FR: 'Francés',
      DE: 'Alemán',
      PT: 'Portugués',
      PO: 'Portugués',
      IT: 'Italiano',
      ZH: 'Chino mandarín',
      JA: 'Japonés',
      AR: 'Árabe',
      RU: 'Ruso',
      KO: 'Coreano',
      NL: 'Neerlandés',
      SV: 'Sueco',
      NO: 'Noruego',
      DA: 'Danés',
      FI: 'Finlandés',
      PL: 'Polaco',
      TR: 'Turco',
      HI: 'Hindi',
      BN: 'Bengalí',
      CA: 'Catalán',
      EU: 'Euskera',
      GL: 'Gallego',
      RO: 'Rumano',
      UK: 'Ucraniano',
      EL: 'Griego',
      CS: 'Checo',
      HU: 'Húngaro',
      HR: 'Croata',
      SK: 'Eslovaco',
      SL: 'Esloveno',
      SR: 'Serbio',
      BS: 'Bosnio',
      BG: 'Búlgaro',
      LT: 'Lituano',
      LV: 'Letón',
      ET: 'Estonio',
      HE: 'Hebreo',
      FA: 'Persa',
      UR: 'Urdu',
      VI: 'Vietnamita',
      TH: 'Tailandés',
      ID: 'Indonesio',
      MS: 'Malayo',
      SW: 'Suajili',
      OTHER: 'Otro',
    },
    LANGUAGE_PROFICIENCY: {
      NATIVE: 'Nativo',
      FLUENT: 'Fluido',
      ADVANCED: 'Avanzado',
      UPPER_INTERMEDIATE: 'Intermedio alto',
      INTERMEDIATE: 'Intermedio',
      LOWER_INTERMEDIATE: 'Intermedio bajo',
      ELEMENTARY: 'Elemental',
      BEGINNER: 'Básico',
      BASIC: 'Básico',
      A1: 'A1 - Básico',
      A2: 'A2 - Elemental',
      B1: 'B1 - Intermedio',
      B2: 'B2 - Intermedio alto',
      C1: 'C1 - Avanzado',
      C2: 'C2 - Maestría',
    },
    CV_CURRICULUM: 'CV / Currículum',
    VIEW_CV: 'Ver',
    DOWNLOAD_CV: 'Descargar',
    INTERVIEW_SECTION: 'Entrevista y Preguntas Directas',
    INTERVIEW: 'Entrevista',
    INTERVIEW_QUESTION_NUMBER: 'Entrevista',
    DIRECT_QUESTIONS: 'Preguntas Directas',
    QUESTION_NUMBER: 'Pregunta Directa',
    VIDEOS: 'videos',
    ANSWERS: 'respuestas',
    CANDIDATE_INFO: 'Presentación, Formación, Experiencia y CV / Currículum',
    SECTIONS_AVAILABLE: 'secciones disponibles',
    PRESENTATION: 'Presentación',
    EDUCATION: 'Formación',
    EXPERIENCE: 'Experiencia',
    NO_REQUIREMENTS: 'No se han especificado requisitos.',
    NO_DESIRED_REQUIREMENTS: 'Esta oferta no tiene requisitos deseados.',
    NO_HARD_SKILLS: '{{ name }} no ha registrado ninguna aptitud técnica.',
    NO_SOFT_SKILLS: '{{ name }} no ha registrado ninguna aptitud interpersonal.',
    NO_TOOLS: '{{ name }} no ha registrado ninguna otra competencia.',
    NO_CV: 'No hay CV disponible.',
    NO_INTERVIEW_VIDEOS: 'No hay videos de entrevista disponibles.',
    SKIPPED: 'Pregunta no respondida por candidat@',
    SKIPPED_PLURAL: 'sin respuesta',
    NO_SPECIFIC_QUESTIONS: 'No hay preguntas específicas respondidas.',
    NO_PRESENTATION: 'No hay presentación disponible.',
    NO_EXPERIENCE: 'No hay información de experiencia disponible.',
    NO_EDUCATION: 'No hay información de formación disponible.',
    DISCARD_REASON: 'Motivo del descarte:',
    HISTORY: 'Historial',
    NO_HISTORY: 'No hay eventos en el historial.',
    NEXT: 'Siguiente Candidat@',
    NO_NEXT: 'No hay más candidat@s en esta etapa, cambia de tab para ver otr@s candidat@s',
    PREVIOUS: 'Anterior Candidat@',
    NO_PREVIOUS: 'No hay más candidat@s en esta etapa, cambia de tab para ver otr@s candidat@s',
    EMPTY_STATE: {
      ENROLLED_MOUSE_OVER: 'No hay más candidat@s en esta oferta',
      NO_CANDIDATES: {
        TITLE: 'Aún no hay candidat@s inscrit@s en esta oferta.',
        PUBLISHED_SUBTITLE: 'Tu oferta acaba de publicarse y aún no tiene candidat@s. A medida que se inscriban, l@s verás en esta pantalla.',
        MEANWHILE_SUGGESTED: 'Mientras tanto, explora el tab "Sugerid@s".',
        EMAIL_NOTIFICATION: 'Te avisaremos por email cuando haya 5 inscrit@s para que los revises.',
        MESSAGE: '',
        BUTTON: 'Ir a Panel de ofertas',
      },
      ALL: {
        TITLE: 'No hay candidat@s.',
        MESSAGE: 'No hay candidat@s en esta etapa del proceso de selección.',
      },
      ENROLLED: {
        TITLE: 'No hay candidat@s Por revisar.',
        MESSAGE: 'No hay candidat@s en esta etapa del proceso de selección.',
      },
      IN_PROGRESS: {
        TITLE: 'No hay candidat@s Preseleccionad@s.',
        MESSAGE: 'No hay candidat@s en esta etapa del proceso de selección.',
      },
      SELECTED: {
        TITLE: 'No hay candidat@s Finalistas.',
        MESSAGE: 'No hay candidat@s en esta etapa del proceso de selección.',
      },
      DISCARDED: {
        TITLE: 'No hay candidat@s Descartad@s.',
        MESSAGE: 'No se encontraron candidat@s descartad@s para esta oferta.',
      },
      SUGGESTED: {
        TITLE: 'No hay candidat@s Sugerid@s.',
        MESSAGE: 'No se encontraron candidat@s sugerid@s para esta oferta.',
      },
      DEFAULT: {
        TITLE: 'No hay candidat@s disponibles.',
        MESSAGE: 'No hay candidat@s en esta etapa del proceso de selección.',
      },
      VIEW_ALL: 'Ver tod@s l@s candidat@s',
      GO_TO_SUGGESTED: 'Ir a Sugerid@s',
    },
  },

};
